module.exports = __webpack_public_path__ + "static/media/looking.f94afeb0.jpg";